"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BracketMatchControllerApi = void 0;
var runtime = require("../runtime");
var index_1 = require("../models/index");
/**
 *
 */
var BracketMatchControllerApi = /** @class */ (function (_super) {
    __extends(BracketMatchControllerApi, _super);
    function BracketMatchControllerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     */
    BracketMatchControllerApi.prototype.allocateBracketMatchRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['id'] == null) {
                            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling allocateBracketMatch().');
                        }
                        if (requestParameters['bracketMatchAllocateCommand'] == null) {
                            throw new runtime.RequiredError('bracketMatchAllocateCommand', 'Required parameter "bracketMatchAllocateCommand" was null or undefined when calling allocateBracketMatch().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters['expand'] != null) {
                            headerParameters['expand'] = String(requestParameters['expand']);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer-jwt", ["read", "write"])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/competition/bracket/match/{id}/_allocate".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters['id']))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.BracketMatchAllocateCommandToJSON)(requestParameters['bracketMatchAllocateCommand']),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.BracketMatchResourceFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    BracketMatchControllerApi.prototype.allocateBracketMatch = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.allocateBracketMatchRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    BracketMatchControllerApi.prototype.bulkCreateMatchesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['bracketId'] == null) {
                            throw new runtime.RequiredError('bracketId', 'Required parameter "bracketId" was null or undefined when calling bulkCreateMatches().');
                        }
                        if (requestParameters['bracketMatchBulkCreateCommand'] == null) {
                            throw new runtime.RequiredError('bracketMatchBulkCreateCommand', 'Required parameter "bracketMatchBulkCreateCommand" was null or undefined when calling bulkCreateMatches().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer-jwt", ["read", "write"])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/competition/bracket/{bracketId}/match/_bulk-create".replace("{".concat("bracketId", "}"), encodeURIComponent(String(requestParameters['bracketId']))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.BracketMatchBulkCreateCommandToJSON)(requestParameters['bracketMatchBulkCreateCommand']),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.ContentResourceBracketMatchResourceFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    BracketMatchControllerApi.prototype.bulkCreateMatches = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bulkCreateMatchesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    BracketMatchControllerApi.prototype.createBracketMatchRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['bracketId'] == null) {
                            throw new runtime.RequiredError('bracketId', 'Required parameter "bracketId" was null or undefined when calling createBracketMatch().');
                        }
                        if (requestParameters['bracketMatchCreateCommand'] == null) {
                            throw new runtime.RequiredError('bracketMatchCreateCommand', 'Required parameter "bracketMatchCreateCommand" was null or undefined when calling createBracketMatch().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters['expand'] != null) {
                            headerParameters['expand'] = String(requestParameters['expand']);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer-jwt", ["read", "write"])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/competition/bracket/{bracketId}/matches".replace("{".concat("bracketId", "}"), encodeURIComponent(String(requestParameters['bracketId']))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.BracketMatchCreateCommandToJSON)(requestParameters['bracketMatchCreateCommand']),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.BracketMatchResourceFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    BracketMatchControllerApi.prototype.createBracketMatch = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createBracketMatchRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    BracketMatchControllerApi.prototype.queryBracketMatchesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['bracketId'] == null) {
                            throw new runtime.RequiredError('bracketId', 'Required parameter "bracketId" was null or undefined when calling queryBracketMatches().');
                        }
                        queryParameters = {};
                        if (requestParameters['round'] != null) {
                            queryParameters['round'] = requestParameters['round'];
                        }
                        if (requestParameters['state'] != null) {
                            queryParameters['state'] = requestParameters['state'];
                        }
                        headerParameters = {};
                        if (requestParameters['expand'] != null) {
                            headerParameters['expand'] = String(requestParameters['expand']);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer-jwt", ["read", "write"])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/competition/bracket/{bracketId}/matches".replace("{".concat("bracketId", "}"), encodeURIComponent(String(requestParameters['bracketId']))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.ContentResourceBracketMatchResourceFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    BracketMatchControllerApi.prototype.queryBracketMatches = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.queryBracketMatchesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    BracketMatchControllerApi.prototype.readBracketMatchRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['id'] == null) {
                            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling readBracketMatch().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (requestParameters['expand'] != null) {
                            headerParameters['expand'] = String(requestParameters['expand']);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer-jwt", ["read", "write"])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/competition/bracket/match/{id}".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters['id']))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.BracketMatchResourceFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    BracketMatchControllerApi.prototype.readBracketMatch = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.readBracketMatchRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    BracketMatchControllerApi.prototype.readBracketMatchMetaRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['id'] == null) {
                            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling readBracketMatchMeta().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer-jwt", ["read", "write"])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/competition/bracket/match/{id}/meta".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters['id']))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.BracketMatchMetaResourceFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    BracketMatchControllerApi.prototype.readBracketMatchMeta = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.readBracketMatchMetaRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    BracketMatchControllerApi.prototype.readChallongeBracketMatchByExternalIdRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['externalId'] == null) {
                            throw new runtime.RequiredError('externalId', 'Required parameter "externalId" was null or undefined when calling readChallongeBracketMatchByExternalId().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (requestParameters['expand'] != null) {
                            headerParameters['expand'] = String(requestParameters['expand']);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer-jwt", ["read", "write"])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/competition/bracket/match/_challonge-by-external-id/{externalId}".replace("{".concat("externalId", "}"), encodeURIComponent(String(requestParameters['externalId']))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.BracketMatchResourceFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    BracketMatchControllerApi.prototype.readChallongeBracketMatchByExternalId = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.readChallongeBracketMatchByExternalIdRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    BracketMatchControllerApi.prototype.readLadderBracketMatchByExternalIdRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['externalId'] == null) {
                            throw new runtime.RequiredError('externalId', 'Required parameter "externalId" was null or undefined when calling readLadderBracketMatchByExternalId().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (requestParameters['expand'] != null) {
                            headerParameters['expand'] = String(requestParameters['expand']);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer-jwt", ["read", "write"])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/competition/bracket/match/_ladder-by-external-id/{externalId}".replace("{".concat("externalId", "}"), encodeURIComponent(String(requestParameters['externalId']))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.BracketMatchResourceFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    BracketMatchControllerApi.prototype.readLadderBracketMatchByExternalId = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.readLadderBracketMatchByExternalIdRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    BracketMatchControllerApi.prototype.removeBracketMatchRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['id'] == null) {
                            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling removeBracketMatch().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer-jwt", ["read", "write"])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/competition/bracket/match/{id}".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters['id']))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     */
    BracketMatchControllerApi.prototype.removeBracketMatch = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.removeBracketMatchRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     */
    BracketMatchControllerApi.prototype.resetBracketMatchRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['id'] == null) {
                            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling resetBracketMatch().');
                        }
                        if (requestParameters['bracketMatchResetCommand'] == null) {
                            throw new runtime.RequiredError('bracketMatchResetCommand', 'Required parameter "bracketMatchResetCommand" was null or undefined when calling resetBracketMatch().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer-jwt", ["read", "write"])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/competition/bracket/match/{id}/reset".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters['id']))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.BracketMatchResetCommandToJSON)(requestParameters['bracketMatchResetCommand']),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.BracketMatchResourceFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    BracketMatchControllerApi.prototype.resetBracketMatch = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.resetBracketMatchRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    BracketMatchControllerApi.prototype.resetBracketMatch1Raw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['id'] == null) {
                            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling resetBracketMatch1().');
                        }
                        if (requestParameters['bracketMatchResetCommand'] == null) {
                            throw new runtime.RequiredError('bracketMatchResetCommand', 'Required parameter "bracketMatchResetCommand" was null or undefined when calling resetBracketMatch1().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer-jwt", ["read", "write"])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/competition/bracket/match/{id}/_reset".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters['id']))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.BracketMatchResetCommandToJSON)(requestParameters['bracketMatchResetCommand']),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.BracketMatchResourceFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    BracketMatchControllerApi.prototype.resetBracketMatch1 = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.resetBracketMatch1Raw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    BracketMatchControllerApi.prototype.updateBracketMatchRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['id'] == null) {
                            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling updateBracketMatch().');
                        }
                        if (requestParameters['advancedMatchUpdateCommand'] == null) {
                            throw new runtime.RequiredError('advancedMatchUpdateCommand', 'Required parameter "advancedMatchUpdateCommand" was null or undefined when calling updateBracketMatch().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters['expand'] != null) {
                            headerParameters['expand'] = String(requestParameters['expand']);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer-jwt", ["read", "write"])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/competition/bracket/match/{id}".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters['id']))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.AdvancedMatchUpdateCommandToJSON)(requestParameters['advancedMatchUpdateCommand']),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.BracketMatchResourceFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    BracketMatchControllerApi.prototype.updateBracketMatch = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateBracketMatchRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    BracketMatchControllerApi.prototype.updateMatchesByBracketRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['bracketId'] == null) {
                            throw new runtime.RequiredError('bracketId', 'Required parameter "bracketId" was null or undefined when calling updateMatchesByBracket().');
                        }
                        if (requestParameters['bracketMatchUpdateByQuery'] == null) {
                            throw new runtime.RequiredError('bracketMatchUpdateByQuery', 'Required parameter "bracketMatchUpdateByQuery" was null or undefined when calling updateMatchesByBracket().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (requestParameters['expand'] != null) {
                            headerParameters['expand'] = String(requestParameters['expand']);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer-jwt", ["read", "write"])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/competition/bracket/{bracketId}/matches".replace("{".concat("bracketId", "}"), encodeURIComponent(String(requestParameters['bracketId']))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, index_1.BracketMatchUpdateByQueryToJSON)(requestParameters['bracketMatchUpdateByQuery']),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.TotalElementsResourceFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    BracketMatchControllerApi.prototype.updateMatchesByBracket = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateMatchesByBracketRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    BracketMatchControllerApi.prototype.viewBracketMatchAccountsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['id'] == null) {
                            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling viewBracketMatchAccounts().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (requestParameters['expand'] != null) {
                            headerParameters['expand'] = String(requestParameters['expand']);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer-jwt", ["read", "write"])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/competition/bracket/match/{id}/_view/accounts".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters['id']))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.ContentResourceContactAccountResourceFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    BracketMatchControllerApi.prototype.viewBracketMatchAccounts = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.viewBracketMatchAccountsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    BracketMatchControllerApi.prototype.viewBracketMatchesByCompetitionRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['competitionId'] == null) {
                            throw new runtime.RequiredError('competitionId', 'Required parameter "competitionId" was null or undefined when calling viewBracketMatchesByCompetition().');
                        }
                        queryParameters = {};
                        if (requestParameters['bracket'] != null) {
                            queryParameters['bracket'] = requestParameters['bracket'];
                        }
                        if (requestParameters['entry'] != null) {
                            queryParameters['entry'] = requestParameters['entry'];
                        }
                        if (requestParameters['state'] != null) {
                            queryParameters['state'] = requestParameters['state'];
                        }
                        if (requestParameters['round'] != null) {
                            queryParameters['round'] = requestParameters['round'];
                        }
                        if (requestParameters['hasEscalation'] != null) {
                            queryParameters['hasEscalation'] = requestParameters['hasEscalation'];
                        }
                        if (requestParameters['sortDesc'] != null) {
                            queryParameters['sortDesc'] = requestParameters['sortDesc'];
                        }
                        if (requestParameters['page'] != null) {
                            queryParameters['page'] = requestParameters['page'];
                        }
                        if (requestParameters['size'] != null) {
                            queryParameters['size'] = requestParameters['size'];
                        }
                        headerParameters = {};
                        if (requestParameters['expand'] != null) {
                            headerParameters['expand'] = String(requestParameters['expand']);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer-jwt", ["read", "write"])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/competition/{competitionId}/_view/matches".replace("{".concat("competitionId", "}"), encodeURIComponent(String(requestParameters['competitionId']))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.ContentResourceBracketMatchResourceFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    BracketMatchControllerApi.prototype.viewBracketMatchesByCompetition = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.viewBracketMatchesByCompetitionRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    BracketMatchControllerApi.prototype.viewBracketMatchesByRepresentingRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['representing'] == null) {
                            throw new runtime.RequiredError('representing', 'Required parameter "representing" was null or undefined when calling viewBracketMatchesByRepresenting().');
                        }
                        queryParameters = {};
                        if (requestParameters['competition'] != null) {
                            queryParameters['competition'] = requestParameters['competition'];
                        }
                        if (requestParameters['entry'] != null) {
                            queryParameters['entry'] = requestParameters['entry'];
                        }
                        if (requestParameters['state'] != null) {
                            queryParameters['state'] = requestParameters['state'];
                        }
                        if (requestParameters['round'] != null) {
                            queryParameters['round'] = requestParameters['round'];
                        }
                        if (requestParameters['sortDesc'] != null) {
                            queryParameters['sortDesc'] = requestParameters['sortDesc'];
                        }
                        if (requestParameters['page'] != null) {
                            queryParameters['page'] = requestParameters['page'];
                        }
                        if (requestParameters['size'] != null) {
                            queryParameters['size'] = requestParameters['size'];
                        }
                        headerParameters = {};
                        if (requestParameters['expand'] != null) {
                            headerParameters['expand'] = String(requestParameters['expand']);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer-jwt", ["read", "write"])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/competition/_view/matches-by-representing/{representing}".replace("{".concat("representing", "}"), encodeURIComponent(String(requestParameters['representing']))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.ContentResourceBracketMatchResourceFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    BracketMatchControllerApi.prototype.viewBracketMatchesByRepresenting = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.viewBracketMatchesByRepresentingRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    BracketMatchControllerApi.prototype.viewCompetitionEntryMatchesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['id'] == null) {
                            throw new runtime.RequiredError('id', 'Required parameter "id" was null or undefined when calling viewCompetitionEntryMatches().');
                        }
                        queryParameters = {};
                        if (requestParameters['bracket'] != null) {
                            queryParameters['bracket'] = requestParameters['bracket'];
                        }
                        if (requestParameters['state'] != null) {
                            queryParameters['state'] = requestParameters['state'];
                        }
                        if (requestParameters['hasEscalation'] != null) {
                            queryParameters['hasEscalation'] = requestParameters['hasEscalation'];
                        }
                        if (requestParameters['sortDesc'] != null) {
                            queryParameters['sortDesc'] = requestParameters['sortDesc'];
                        }
                        if (requestParameters['page'] != null) {
                            queryParameters['page'] = requestParameters['page'];
                        }
                        if (requestParameters['size'] != null) {
                            queryParameters['size'] = requestParameters['size'];
                        }
                        headerParameters = {};
                        if (requestParameters['expand'] != null) {
                            headerParameters['expand'] = String(requestParameters['expand']);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer-jwt", ["read", "write"])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/competition/entry/{id}/_view/matches".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters['id']))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.ContentResourceBracketMatchResourceFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    BracketMatchControllerApi.prototype.viewCompetitionEntryMatches = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.viewCompetitionEntryMatchesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    BracketMatchControllerApi.prototype.viewMaxRoundRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['bracketId'] == null) {
                            throw new runtime.RequiredError('bracketId', 'Required parameter "bracketId" was null or undefined when calling viewMaxRound().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer-jwt", ["read", "write"])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/competition/bracket/{bracketId}/matches/_view/maxRound".replace("{".concat("bracketId", "}"), encodeURIComponent(String(requestParameters['bracketId']))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        if (this.isJsonMime(response.headers.get('content-type'))) {
                            return [2 /*return*/, new runtime.JSONApiResponse(response)];
                        }
                        else {
                            return [2 /*return*/, new runtime.TextApiResponse(response)];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     */
    BracketMatchControllerApi.prototype.viewMaxRound = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.viewMaxRoundRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    BracketMatchControllerApi.prototype.viewPersonalRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['competitionId'] == null) {
                            throw new runtime.RequiredError('competitionId', 'Required parameter "competitionId" was null or undefined when calling viewPersonal().');
                        }
                        queryParameters = {};
                        if (requestParameters['state'] != null) {
                            queryParameters['state'] = requestParameters['state'];
                        }
                        if (requestParameters['sortDesc'] != null) {
                            queryParameters['sortDesc'] = requestParameters['sortDesc'];
                        }
                        headerParameters = {};
                        if (requestParameters['expand'] != null) {
                            headerParameters['expand'] = String(requestParameters['expand']);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer-jwt", ["read", "write"])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/competition/{competitionId}/bracket/match/_view/personal".replace("{".concat("competitionId", "}"), encodeURIComponent(String(requestParameters['competitionId']))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.ContentResourceBracketMatchResourceFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    BracketMatchControllerApi.prototype.viewPersonal = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.viewPersonalRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return BracketMatchControllerApi;
}(runtime.BaseAPI));
exports.BracketMatchControllerApi = BracketMatchControllerApi;
